import { render, staticRenderFns } from "./MaintenanceCategories.vue?vue&type=template&id=504fbd81&scoped=true"
import script from "./MaintenanceCategories.ts?vue&type=script&lang=ts&external"
export * from "./MaintenanceCategories.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504fbd81",
  null
  
)

export default component.exports